import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { TableHeaderComponent } from './table-header/table-header.component';
import { TableRowComponent } from './table-row/table-row.component';
import { TableColumnComponent } from './table-column/table-column.component';
import { RouterModule } from '@angular/router';
import { TableDropdownSectionComponent } from './table-dropdown-section/table-dropdown-section.component';
import { TableDropdownHeaderComponent } from './table-dropdown-header/table-dropdown-header.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    TableComponent, 
    TableHeaderComponent, 
    TableRowComponent, 
    TableColumnComponent, 
    TableDropdownSectionComponent, 
    TableDropdownHeaderComponent,
  ],
  exports: [
    TableComponent, 
    TableHeaderComponent, 
    TableRowComponent, 
    TableColumnComponent,
    TableDropdownSectionComponent, 
    TableDropdownHeaderComponent,
  ]
})
export class TableModule { }
